export default {
  init() {

  },
  finalize() {
    console.log('common.js');
    //Toggle Search
      $('.hamiltonma--search--trigger').click(function() {
        $('.search--hamilton-overlay-wrapper').toggleClass('search--hamilton-overlay-wrapper--is-open');
      });

      //Close Search
      $('#js--trigger-close-search').click(function() {
        $('.search--hamilton-overlay-wrapper').removeClass('search--hamilton-overlay-wrapper--is-open');
      });

      //Toggle Quicklinks
      $('[data-toggle="quicklinks"]').on('click', function () {
        $('body').toggleClass('quicklinks-open');
      });

      //Read More
      $( '.js--hamilton-content-wrapper--trigger' ).click(function() {
        $( '.hamilton--toggle-content-wrapper' ).toggleClass( 'hamilton--toggle-content-wrapper--open' );
        $( this ).toggleClass( 'hamilton--read-more-link--clicked' );
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js